export default "* Dyst\n* Krop\n* Motorik\n* Sanser\n";